import { usePropertySearchContext } from './PropertySearchContext'

export const useIsReservationUi = () => {
  const searchContext = usePropertySearchContext()
  return !!searchContext?.isReservationUi
}
